<script setup>
import placeholder from '../../../img/product-placeholder.webp';
import ProductBackgroundIcon from '../../../img/product-background.svg?component';
import {Link} from '@inertiajs/vue3';
import {computed, inject} from 'vue';
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import discountLabel from '@i/discount_label.svg';
import ProductPrice from "@/Components/Product/ProductPrice.vue";

const route = inject('route');

const props = defineProps({
  product: Object,
  options: {
    type: Array,
    default: () => [],
  },
});

const mainVariant = computed(() => {
  if (props.product?.variants?.length > 0) {
    return props.product?.variants?.reduce(function (prev, current) {
      return (prev.order < current.order) ? prev : current
    });
  }

  return props.product?.package_variants?.reduce(function (prev, current) {
    return (prev.order < current.order) ? prev : current
  });
});

const selectedVariant = computed(() => {
  if (props.options.length === 0) {
    return mainVariant.value;
  }

  const variant = props.product?.variants?.find(variant => {
    return variant.values.every(value => {
      return props.options.includes(value.id);
    });
  });

  return variant ? variant : mainVariant.value;
})

const media = computed(() => {
  return selectedVariant.value?.images?.[0] ?? props.product?.images?.[0] ?? null;
});

</script>
<template>
    <Link
        :href="route('public.products.show', { product: product.page_slug })"
        class="flex h-full flex-col"
    >
        <slot />

        <div class="relative aspect-[155/186]  bg-[#F0F0F0] lg:aspect-[400/480]">
            <div class="absolute inset-0 size-full overflow-hidden">
                <ProductBackgroundIcon />
            </div>
            <div class="isolate flex h-full items-center justify-center">
                <ImgMedia
                    v-if="media"
                    :media="media"
                    :sizes="{ '768px': '360px', default: '100vw' }"
                />
                <img
                    v-else
                    :src="placeholder"
                    alt="Product image"
                    class="rounded-8 size-full border border-gray-100 object-cover"
                    loading="lazy"
                >
            </div>
            <img
                v-if="selectedVariant?.discount_is_active"
                :src="discountLabel"
                alt="discounted"
                class="pointer-events-none absolute left-0 top-8"
            >
        </div>
        <div class="w-full">
            <div class="mx-4 h-2 bg-gradient-to-r from-primary to-secondary" />
        </div>


        <div class="lg:text-md flex flex-1 flex-col justify-between space-y-4 py-8 text-sm">
            <div>
                {{ selectedVariant?.title }}
            </div>

            <ProductPrice :variant="selectedVariant" />
        </div>
    </Link>
</template>
